
import { Directive, TemplateRef, ViewContainerRef } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

@Directive({
  selector: '[sdMobile]'
})
export class MobileDirective {
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainerRef: ViewContainerRef,
    deviceService: DeviceDetectorService,
  ) {
    if (deviceService.isMobile()) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    }
  }
}
